import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { HotlineLpHeader } from '@/feature/hotline/lp/component/HotlineLpHeader';
import { HotlineLpSectionConcept } from '@/feature/hotline/lp/component/HotlineLpSectionConcept';
import { HotlineLpSectionFaq } from '@/feature/hotline/lp/component/HotlineLpSectionFaq';
import { HotlineLpSectionPrice } from '@/feature/hotline/lp/component/HotlineLpSectionPrice';
import { HotlineLpSectionScene } from '@/feature/hotline/lp/component/HotlineLpSectionScene';
import { HotlineLpSectionStep } from '@/feature/hotline/lp/component/HotlineLpSectionStep';
import { HotlineLpSectionTop } from '@/feature/hotline/lp/component/HotlineLpSectionTop';
import { hotlineLpViewStyle } from '@/feature/hotline/lp/page/style';
import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * 匿名コンサルホットラインのLP（View 部分のみ）
 */
export const HotlineLpView = (props) => {
    const { consultationLink, isGuest } = props;
    const style = hotlineLpViewStyle();
    // スクロールを管理するstate
    const { boolState: isScrolled, changeFalse: setIsNotScrolled, changeTrue: setIsScrolled, } = useBoolState();
    const scrollTriggerRef = useRef(null);
    // スクロール検知を追加
    useEffect(() => {
        const handleScroll = () => {
            // ビューポートの位置を取得
            const isScrolledNow = window.scrollY > 0;
            if (isScrolledNow) {
                setIsScrolled();
            }
            else {
                setIsNotScrolled();
            }
        };
        // スクロールイベントリスナーを追加
        window.addEventListener('scroll', handleScroll);
        // クリーンアップ関数でリスナーを削除
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [setIsScrolled, setIsNotScrolled, scrollTriggerRef]);
    return (_jsxs("div", Object.assign({ className: style.base(), ref: scrollTriggerRef }, { children: [_jsx(HotlineLpHeader, { isGuest: isGuest, isScrolled: isScrolled }), _jsxs("div", Object.assign({ className: style.contents() }, { children: [_jsx(HotlineLpSectionTop, { buttonLink: consultationLink }), _jsx(HotlineLpSectionConcept, { className: '-mt-[12px] sm:-mt-[54px] md:mt-[166px] xl:mt-[304px] min-[1440px]:mt-[min(30vw,576px)]' }), _jsx(HotlineLpSectionScene, { buttonLink: consultationLink, className: 'mt-64 lg:mt-[211px]' }), _jsx(HotlineLpSectionStep, { buttonLink: consultationLink, className: 'mt-64 lg:mt-[160px]', id: 'step' }), _jsx(HotlineLpSectionPrice, { className: 'mt-64 lg:mt-120', id: 'price' }), _jsx(HotlineLpSectionFaq, { className: 'mt-64 lg:mt-120 mb-120', id: 'faq' })] }))] })));
};
